import { SEND_TRY_IT_OUT_ASYNC, SET_ERROR, SET_USER_MAILBOX_ID } from './constants'

export const sendTryItOutSuccess = (data) => ({
  type: SEND_TRY_IT_OUT_ASYNC.SUCCESS,
  payload: { data },
})
export const sendTryItOutError = (error) => ({
  type: SEND_TRY_IT_OUT_ASYNC.ERROR,
  error,
})

const setError = (value) => ({
  type: SET_ERROR,
  payload: { value },
})

export const setUserMailboxId = (data) => ({
  type: SET_USER_MAILBOX_ID,
  payload: { data },
})

export default {
  setError,
}
